var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"avatar",style:(_vm.avatarStyle)},[(_vm.src)?_c('img',{attrs:{"src":_vm.src,"alt":"avatar"}}):_c('img',{attrs:{"src":require("@/assets/img/default/avatar.png"),"alt":"avatar"}})])}
var staticRenderFns = []

export { render, staticRenderFns }